// Где фронт берёт API в разработке. Адрес задаётся одной строкой в .env.development.local:
//
//   REACT_APP_API_URL=http://planr.local:3001/api        — свой бэкенд
//   REACT_APP_API_URL=https://test.rost.g00.link/api     — стенд
//
// Отсюда же адрес читает dev-прокси (vite.config.ts), поэтому смена стенда — правка
// одной строки. Схему можно не писать: test.rost.g00.link/api тоже подойдёт.
//
// Зачем прокси: куку чужого стенда (SameSite=None; Secure) браузер для страницы на
// localhost считает сторонней — логин проходит, а следующий запрос улетает без куки
// и фронт показывает «Сессия истекла». Поэтому к чужому адресу фронт обращается через
// свой origin (/api), а прокси переправляет запрос на стенд и переписывает домен куки.
//
// Файл читают и браузер, и конфиг сборки, поэтому он не знает ни про process.env,
// ни про import.meta.env: режим передаётся аргументом.

/** Куда фронт шлёт запросы, когда работает через прокси */
export const PROXY_PATH = "/api";

/**
 * Адрес как его написали в переменной, но со схемой: без неё считаем https.
 * Пусто — переменная не задана либо в ней относительный путь
 */
function absolute(value: string | undefined) {
    const address = (value || "").trim();

    if (!address || address.startsWith("/")) {
        return "";
    }

    return /^https?:\/\//i.test(address) ? address : `https://${address}`;
}

/**
 * Origin стенда для dev-прокси: схема, хост и порт без пути
 */
export function apiOrigin(value: string | undefined) {
    const address = absolute(value);

    if (!address) {
        return "";
    }

    try {
        return new URL(address).origin;
    } catch (e) {
        return "";
    }
}

/**
 * Адрес, по которому фронт зовёт API. Чужой хост — идём через свой origin, его
 * разбирает dev-прокси; свой бэкенд и сборка для сервера обращаются напрямую
 */
export function apiUrl(value: string | undefined, hostname: string, isDevelopment: boolean): string {
    const address = absolute(value);

    if (!isDevelopment || !address) {
        return value || "";
    }

    try {
        const url = new URL(address);

        // свой хост — обращаемся напрямую, адрес отдаём ровно как его написали
        return url.hostname === hostname ? value || "" : url.pathname.replace(/\/$/, "") || PROXY_PATH;
    } catch (e) {
        return value || "";
    }
}
